import { useGSAP } from "@gsap/react";
import { processSteps } from "../constants";
import { animateWithGsap } from "../utils/animations";

const Process = () => {
  useGSAP(() => {
    animateWithGsap("#processus .section-head", { y: 0, opacity: 1 });
    animateWithGsap(
      "#processus .process-step",
      { y: 0, opacity: 1, stagger: 0.15 },
      { start: "top 80%" }
    );
  }, []);

  return (
    <section id="processus" className="section-padding">
      <div className="section-container">
        <div className="section-head reveal text-center flex flex-col items-center">
          <span className="eyebrow">Comment ça marche</span>
          <h2 className="section-title">Simple, en 3 étapes</h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-5">
          {processSteps.map((step, i) => (
            <div key={step.step} className="process-step reveal relative text-center px-4">
              <span className="font-display font-extrabold text-6xl text-white/10">
                {step.step}
              </span>
              <h3 className="mt-2 font-display font-semibold text-xl">{step.title}</h3>
              <p className="mt-3 text-chrome-dark text-sm leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>

              {/* Connecteur entre les étapes (desktop) */}
              {i < processSteps.length - 1 && (
                <span className="hidden md:block absolute top-10 -right-2.5 text-ferrari/50 text-2xl">
                  →
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
